export default __webpack_public_path__ + "static/media/Q7.d348ae37.jpg";